<template>
  <LevelPopup @close="() => $router.push('/test')" btnText="Продолжить" wide>
    <template #description>
      <div style="position: relative; padding-bottom: 56.25%; height: 0;"><iframe src="https://www.loom.com/embed/97f987c80a084605a1438a855d5d1de3" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>
    </template>
  </LevelPopup>
</template>
<script>
import LevelPopup from '@/components/LevelPopup/LevelPopup'

export default {
  name: 'Video',
  components: { LevelPopup },
}
</script>
